<template>
	<div class="pa-3">
		<v-row class="ma-0">
			<div v-if="!holiday_create">Public Holiday settings</div>
			<div v-else>Create Public Holiday</div>
		</v-row>
		<template v-if="!holiday_detail && !holiday_create">
			<v-row class="mx-0 my-3" justify="space-between" no-gutters>
				<v-col cols="3">
					<v-btn class="text-capitalize white--text" color="#605AF6" @click="holiday_create = true">
						<v-icon class="mr-2">mdi-plus</v-icon>
						<span>Create Public Holiday</span>
					</v-btn>
				</v-col>
				<v-col cols="3">
					<v-text-field							
						v-model="search_key"
						:color="$attrs.color"
						background-color="#FAFAFA"
						placeholder="Search"
						outlined
						dense
						hide-details	
					>
					</v-text-field>
				</v-col>
				<v-col cols="3">
					<v-row>
						<v-col>
							<v-menu offset-y :close-on-content-click="false">
								<template v-slot:activator="{ on, attrs }">
									<v-btn style="width: 146px" color="#FAFAFA" v-bind="attrs" v-on="on" class="text-capitalize">
										<span class="btn-text">Recurrences</span>
										<FirstList :color="'rgba(25, 42, 62, 0.7)'" class="ml-1"/>
									</v-btn>
								</template>
								<v-card class="px-2 pb-2">
									<v-checkbox
										v-for="item of recurrences"
										:key="item.key"
										v-model="recurrency"
										:label="item.text"
										:value="item.value"
										:color="$attrs.color"
										hide-details
									>
									</v-checkbox>
								</v-card>
							</v-menu>
						</v-col>
						<v-col>
							<v-menu offset-y :close-on-content-click="false" >
								<template v-slot:activator="{ on, attrs }">
									<v-btn style="width: 146px" olor="#FAFAFA" v-bind="attrs" v-on="on" class="text-capitalize">
										<span class="btn-text">Country</span>
										<FirstList :color="'rgba(25, 42, 62, 0.7)'" class="ml-1"/>
									</v-btn>
								</template>
								<v-card class="px-2 pb-2">
									<v-checkbox
										v-model="all_select_country"
										label="Select all"
										:color="$attrs.color"
										hide-details
									>
									</v-checkbox>
									<v-divider class="mt-2"/>
									<v-checkbox
										v-for="item of countries"
										:key="item.key"
										v-model="country"
										:label="item.text"
										:value="item.value"
										:color="$attrs.color"
										hide-details
									>
									</v-checkbox>
								</v-card>
							</v-menu>
						</v-col>
						<v-col>
							<v-menu offset-y :close-on-content-click="false">
								<template v-slot:activator="{ on, attrs }">
									<v-btn olor="#FAFAFA" v-bind="attrs" v-on="on" class="text-capitalize">
										<span class="btn-text">State</span>
										<FirstList :color="'rgba(25, 42, 62, 0.7)'" class="ml-1"/>
									</v-btn>
								</template>
								<v-card class="px-2 pb-2">
									<v-checkbox
										v-model="all_select_state"
										label="Select all"
										:color="$attrs.color"
										hide-details
									>
									</v-checkbox>
									<v-divider class="mt-2"/>
									<v-treeview
										v-model="select_state"
										:items="states"
										:selected-color="$attrs.color"
										expand-icon="mdi-chevron-down"
										selectable
										return-object
										open-all
									></v-treeview>
								</v-card>
							</v-menu>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
			<v-data-table
				:headers="headers"
				:items="holidays"
				:single-expand="true"
				:expanded.sync="expanded"
				item-key="name"
				hide-default-footer
				show-expand
				@item-expanded="onExpanded"
			>
				<template v-slot:[`item.plus`]="{ item }">
					<PlusMenu
						@click-menu-item="onClickMenu($event, item)"
						@delete="onDeleteHoliday(item)"
					/>
				</template>
				<template v-slot:footer>
					<div class="pagination">
						<v-pagination
							v-model="page"
							:color="$attrs.color"
							:length="getPaginationTotal()"
							:total-visible="$vuetify.breakpoint.xs ? 3: 5"
							circle
						></v-pagination>
						<div class="pagination-text">show</div>
						<div class="pagination-text-page">{{ countPerpage}}/page</div>
						<v-menu offset-y>
							<template v-slot:activator="{ on, attrs }">
								<div v-bind="attrs" v-on="on"><Down class="down"/></div>
							</template>
							<v-list>
								<v-list-item-title v-for="(pageOption, index) in pageOptions" :key="index" class="option-text" @click="onClickOption(pageOption)">
									{{pageOption}}
								</v-list-item-title>
							</v-list>
						</v-menu>
					</div>
				</template>
			</v-data-table>
		</template>
		<PublicDetail
			v-if="holiday_detail && !holiday_create"
			:color="$attrs.color"
			:holiday="holiday_detail"
			:isDuplicate="is_duplicate"
			@back="holiday_detail = null; is_duplicate = false"
		/>
		<PublicDetail
			v-if="holiday_create"
			:color="$attrs.color"
			:holiday="null"
			@back="holiday_create = false"
		/>
		<DeleteConfirmDialog 
			v-if="delete_visible"
			:visible="delete_visible" 
			:color="'error'"
			:title="`Delete (${delete_holiday_item.name})`" 
			:content="`You are about to delete (${delete_holiday_item.name}). This action will delete all future occurences of this Public Holiday from today. This action is irreversible. Are you sure?`"
			:ok="'Yes, Delete'"
			:icon_name_title="'mdi-alert-circle'"
			:icon_name_front="'mdi-delete-outline'"
			:maxWidth="500"
			@cancel="onDeleteCancel()"
			@ok="onDelete()"
		/>
	</div>
</template>
<script>
import FirstList from "@/components/icons/first_list";
import Down from '@/components/icons/down';
import PlusMenu from '@/views/settings/holiday_menu.vue';

import PublicDetail from '@/views/settings/holiday_detail.vue';
import DeleteConfirmDialog from "@/components/dialogs/delete_comfirm_dialog.vue";

import moment from 'moment';
import config from "@/config.js";

const Recurrences = [
	{
		key: 'same',
		text: 'Same Date every year',
		value: 0
	},
	{
		key: 'different',
		text: 'Different Date every year',
		value: 1
	},
	{
		key: 'day',
		text: '(Nth Day) of (Month) every year',
		value: 2
	}
];

const Countries = [
	{
		key: 'australia',
		text: 'Australia',
		value: 0
	},
	{
		key: 'indonesia',
		text: 'Indonesia',
		value: 1
	},
	{
		key: 'portugal',
		text: 'Portugal',
		value: 2
	},
	{
		key: 'singapore',
		text: 'Singapore',
		value: 3
	},
	{
		key: 'kingdom',
		text: 'United Kingdom',
		value: 4
	},
	{
		key: 'states',
		text: 'United States',
		value: 5
	},
];

const Test_Items = [
	{
		id: 1,
		name: 'Australia',
		children: [
			{ id: 102, name: 'Australian Capital Territory' },
			{ id: 103, name: 'Jervis Bay Territory' },
			{ id: 104, name: 'New South Wales' },
		],
	},
	{
		id: 2,
		name: 'Portugal',
		children: [
			{ id: 202, name: 'Lisbon' },
		],
	}
];

const Test_Holiday_Data = [
	{
		name: 'New Year’s Day',
		date: '2023-01-01',
		recurrence: 0,
		countries: ['Australia', 'Indonesia', 'New Zealand', 'Singapore', 'UK', 'USA'],
		state: 'All'
	},
	{
		name: 'Labour Day',
		date: '2023-03-01',
		recurrence: 1,
		countries: ['Indonesia'],
		state: 'Victoria, Tasmania'
	}
];

const Test_Headers = [
	{ text: '', value: 'data-table-expand' },
	{
		text: 'Name of Holiday',
		align: 'start',
		value: 'name',
		sortable: false,
	},
	{ text: 'Date', value: 'date', sortable: false, },
	{ text: 'Recurrence', value: 'recurrence', sortable: false, },
	{ text: 'Country(ies)', value: 'countries', sortable: false, },
	{ text: 'State(s)', value: 'state', sortable: false, },
	{ text: '', value: 'plus', sortable: false, },
];

export default {
	name: 'Holiday',
	components: {
		FirstList,
		Down,
		PlusMenu,
		PublicDetail,
		DeleteConfirmDialog
	},
	data() {
		return {
			search_key: '',

			recurrences: Recurrences,
			recurrency: [0, 1, 2],

			countries: Countries,
			country: [0, 1, 2],
			all_select_country: false,

			states: Test_Items,
			select_state: [],
			all_select_state: false,

			// holidays: [],
			holidays: Test_Holiday_Data,



			expanded: [],
			headers: Test_Headers,

			page: 1,
			countPerpage: 10,
			pageOptions: config.pageOptions,

			is_detail: false,
			holiday_detail: null,
			is_duplicate: false,

			delete_visible: false,
			delete_holiday_item: null,

			holiday_create: true,
		};
	},
	watch: {
		all_select_country() {
			if (this.all_select_country) {
				this.country = this.countries.map(c => { return c.value });
			} else {
				this.country = [];
			}
		},
		all_select_state() {
			if (this.all_select_state) {
				const select_state_tmp = [];

				this.states.forEach(s => {
					s.children.forEach(child => {
						select_state_tmp.push(child);
					});
				});
				
				this.select_state = select_state_tmp;
			} else {
				this.select_state = [];
			}
		}
	},
	computed: {
		userAddressId() {
			return this.$store.state.user && this.$store.state.user.addressbook.id;
		},
	},
	created() {
		this.$store.commit("push_breadcrumb", {
			exact: true,
			text: 'Public Holidays',
			to: this.$route.path
		});

		// this.getHoliday();
	},
	methods: {
		getHoliday() {
			const params = [];

			params.push("employees=" + this.userAddressId);
			const year_start = moment().startOf('year').format('YYYYMMDD');
			params.push("start_date=" + encodeURIComponent(year_start));

			const year_end = moment().endOf('year').format('YYYYMMDD');
			params.push("end_date=" + encodeURIComponent(year_end));
			params.push("event_types=" + [2,3,4,5,6]);

			let url = "/api/leave";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if (typeof(json) === 'string') {
						json = JSON.parse(json);
					}

					const { status, data, reason } = json;

					if (status === "OK") {
						this.holidays = data.filter(d => { return d.leave_type === config.public_holiday_type });
						console.log('holidays:', this.holidays)
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		onExpanded({item, value}) {
			if (value) {
				this.is_detail = true;
				this.holiday_detail = item;
			}
		},
		onClickMenu(key, item) {
			if (key === 'edit') {
				this.is_detail = true;
				this.holiday_detail = item;
			}

			if (key === 'duplicate') {
				this.is_detail = true;
				this.holiday_detail = item;
				this.is_duplication = true;
			}
		},
		onDeleteHoliday(item) {
			this.delete_holiday_item = item;
			this.delete_visible = true;			
		},
		onDelete() {
			console.log('onDelete', this.delete_holiday_item)
		},
		onDeleteCancel() {
			this.delete_holiday_item = null;
			this.delete_visible = false;
		},
		getPaginationTotal() {
			return Math.ceil(this.holidays.length / this.countPerpage);
		},
		onClickOption(option) {
			this.countPerpage = option;
		},
	}
}
</script>
<style lang="scss" scoped>
.btn-text {
	font-family: Roboto;
	font-size: 14px;
	font-weight: 500;
	line-height: 36px;
	letter-spacing: 0.5px;
	color: rgba(25, 42, 62, 0.7);
}

.pagination {
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;
	background-color: rgba(25, 42, 62, 0.1);
	.pagination-text {
		font-family: Roboto;
		font-style: normal;
		font-weight: normal;
		font-size: 13px;
		line-height: 16px;
		color: rgba(25, 42, 62, 0.5);
	}
	.pagination-text-page {
		font-family: Roboto;
		font-style: normal;
		font-weight: normal;
		font-size: 13px;
		line-height: 16px;
		color: #192A3E;
		margin: 0 8px;
	}
	.down {
		width: 12px;
		height: 12px;
		margin-top: 10px;
		&:hover {
			cursor: pointer;
		}
	}
}
.option-text {
		margin: 0 4px;
		font-family: Roboto;
		font-style: normal;
		font-weight: normal;
		font-size: 13px;
		color: #192A3E;
		&:hover {
			cursor: pointer;
		}
	}

	::v-deep {
		.v-pagination__navigation {
			width: 20px;
			height: 20px;
		}
		.v-pagination__item {
			min-width: 26px;
			height: 26px;
		}
	}
</style>